export class UnprocessableError extends Error {
  constructor(message: string | undefined) {
    super(message || 'Unprocessable')
  }
}
